import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Collapse, Card, CardHeader, CardBody, Container, Col, Row, Button } from 'reactstrap'
import {
  FaCaretDown,
  FaCaretUp,
  FaBan,
  FaCalendarAlt,
  FaEnvelope,
  FaEnvelopeOpen
} from 'react-icons/fa'
import { DatePicker } from 'components/ideal-core-ui'
import { DealCheckbox } from './DealCheckbox'
import s from './ContactCard.scss'
import { EmailComposer } from './EmailComposer'
import cn from 'classnames'
import { timezoneDate, utcDate } from 'utils/helpers'

const ContactCard = ({
  contact,
  cardsOpen,
  removeContact,
  templates,
  toggleContactDeal,
  setContactFollowUpDate,
  index,
  setContactEmailSubject,
  setContactEmailFiles,
  removeFile,
  setContactEmailTemplate,
  setContactEmailTemplateBody,
  sendIndividualEmail,
  setFollowupDate,
  users,
  setCCContacts
}) => {
  const [isOpen, setIsOpen] = useState(cardsOpen)
  const [followupPickerVisible, setFollowupPickerVisible] = useState(false)
  const [isFollowupActive, setIsFollowupActive] = useState(false)

  useEffect(() => {
    setIsOpen(cardsOpen)
  }, [cardsOpen])

  const toggleIsOpen = () => setIsOpen(prevIsOpen => !prevIsOpen)

  return (
    <div className={s.contactCard}>
      <div className={s.buttons}>
        <div className={s.button} onClick={() => removeContact(contact)}>
          <FaBan />
        </div>
        <div className={s.button} onClick={toggleIsOpen}>
          {isOpen ? <FaCaretUp /> : <FaCaretDown />}
        </div>
      </div>
      <Card className={s.content}>
        <CardHeader className={s.header}>
          <div className={cn(s.contactInfo, s.pullLeft)}>
            <p>
              {contact.contactFirstName} {contact.contactLastName} ({contact.contactEmail})
              <span>
                - last emailed on{' '}
                {contact.contactLastEmailedOn
                  ? timezoneDate(contact.contactLastEmailedOn, 'hh:mm a')
                  : 'N/A'}
              </span>
            </p>
            <Link to={`/companies/${contact.company.id}`}>{contact.company.name}</Link>
          </div>
          {contact.hasFollowUpDate && (
            <div className={cn(s.pullRight, s.emailSentNotification)}>
              <FaCalendarAlt />
              Next follow-up successfully set
            </div>
          )}
          {contact.email.sent && (
            <div className={cn(s.pullRight, s.emailSentNotification)}>
              <FaEnvelopeOpen />
              Email sent successfully
            </div>
          )}
        </CardHeader>
        <Collapse isOpen={isOpen}>
          <CardBody>
            <Container>
              <Row>
                <Col lg="3" md="12" sm="12">
                  <div className={s.selectedDeals}>
                    Opportunities following up on:
                    {contact.dealsToFollowup.map(deal => (
                      <DealCheckbox
                        key={deal.id}
                        deal={deal}
                        contact={contact}
                        toggleContactDeal={toggleContactDeal}
                      />
                    ))}
                  </div>
                  {!!contact.otherDealsToFollowUp.length && (
                    <div className={s.otherDeals}>
                      Other opportunities with follow-up date due in the next 2 weeks:
                      <span>(check if you want to include in this follow-up email)</span>
                      {contact.otherDealsToFollowUp.map(deal => (
                        <DealCheckbox
                          key={deal.id}
                          deal={deal}
                          contact={contact}
                          toggleContactDeal={toggleContactDeal}
                        />
                      ))}
                    </div>
                  )}
                </Col>
                <Col lg="7" md="12" sm="12">
                  <EmailComposer
                    setContactEmailFiles={setContactEmailFiles}
                    setContactEmailSubject={setContactEmailSubject}
                    contact={contact}
                    index={index}
                    templates={templates}
                    removeFile={removeFile}
                    setContactEmailTemplate={setContactEmailTemplate}
                    setContactEmailTemplateBody={setContactEmailTemplateBody}
                    users={users}
                    setCCContacts={setCCContacts}
                    ccContacts={contact.ccContacts}
                  />
                </Col>
                <Col lg="2" md="12" sm="12">
                  <div className={s.actionButtons}>
                    <div>
                      <Button
                        className={s.saveBtn}
                        onClick={() => {
                          if (!contact.email.subject || !contact.email.templateBody) return
                          sendIndividualEmail(contact, index)
                          setIsFollowupActive(true)
                        }}
                      >
                        <FaEnvelope />
                        Send Email Now
                      </Button>
                      <Button
                        className={cn({
                          [s.setDate]: !contact.hasFollowUpDate && contact.email.sent
                        })}
                        onClick={() => setFollowupPickerVisible(true)}
                        disabled={!isFollowupActive}
                      >
                        <FaCalendarAlt />
                        Set Next Follow-up Date
                      </Button>
                      {followupPickerVisible && (
                        <div className={s.followupPickerContainer}>
                          <DatePicker
                            value={contact.followUpDate ? timezoneDate(contact.followUpDate) : ''}
                            onChange={value => {
                              const date = value ? utcDate(value) : ''
                              setContactFollowUpDate(contact, date)
                            }}
                          />
                          <Button
                            onClick={() => {
                              setFollowupDate(contact, index, () => {
                                contact.email.sent &&
                                  setTimeout(() => {
                                    setIsOpen(false)
                                  }, 2000)
                              })
                            }}
                            disabled={!contact.followUpDate}
                          >
                            Ok
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </CardBody>
        </Collapse>
      </Card>
    </div>
  )
}

export default ContactCard
